<template>
  <article @click="open" v-if="!isLarge">
    <slot name="image"/>
    <slot name="content"/>
  </article>
  <div :style="{height: elementHeight + 'px'}" v-else>
    <div class="modal is-active" @touchmove="preventOutsideScroll">
      <div class="modal-background"/>
      <div class="modal-content instruction-large">
        <div class="box">
          <figure class="image is-square">
            <responsive-image :desktop="largeImage" :tablet="largeImage" :mobile="largeImage" :blurred="blurredImage" lazy/>
            <div class="overlay">
              <div class="bottom-right">
                <button class="button is-primary" @click="next">{{$t('next')}}</button>
              </div>
            </div>
          </figure>
          <slot name="content"/>
        </div>
      </div>
      <div class="modal-close is-large" aria-label="close" @click="isLarge = false"/>
    </div>
  </div>
</template>

<script>
import ResponsiveImage from '../ResponsiveImage.vue'

export default {
  props: {
    largeImage: String,
    blurredImage: String
  },

  components: {
    ResponsiveImage
  },

  data(){
    return {
      isLarge: false,
      elementHeight: 0
    }
  },

  created(){
    this.$root.$on('instruction-step-by-step', () => {
      if(this.$parent.$children.indexOf(this) === 0){
        this.open()
      }
    })
  },

  methods: {
    open(e){
      if(e && e.srcElement.tagName === 'A') return

      this.$parent.$children.forEach(item => {
        if(item.isLarge) item.isLarge = false
      })

      this.elementHeight = this.$el.clientHeight
      this.isLarge = true
    },

    next(){
      const pos = this.$parent.$children.indexOf(this)
      if(this.$parent.$children.length - 1 > pos){
        this.$parent.$children[pos + 1].open()
      }else{
        this.isLarge = false
        this.$dialog.alert({
          type: 'is-success',
          message: `<h1 class="title has-text-centered">${this.$t('Enjoy your meal!')}</h1>`,
          confirmText: this.$t('Thank you')
        })
      }
    },

    preventOutsideScroll(e){
      if(this.$el === e.srcElement || this.$el.contains(e.srcElement)) return
      e.preventDefault()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/recipe/InstructionItem.vue